import { ArgumentNullError } from '../ArgumentNullError'
import { IDictionary } from '../types/common'

export const validateForNull = (properties: IDictionary<any>) => {
    for (const key of Object.keys(properties)) {
        const value = properties[key]
        if (value === undefined || value === null || Number.isNaN(value)) {
            throw new ArgumentNullError(key, value)
        }
    }
}
